export default "__VITE_ASSET__BhYBN4PX__"